<template>
  <power-bi code="eyJrIjoiNGQyOWZkMzctMGExNS00MDYwLTkyMTYtNmQ5YmRkYTRkN2Q1IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
